import { ApiV3RequiredFieldsResponse } from '../../../api/core/models';

export function apiV3RequiredFieldsToV3RequiredFields(
  apiV3RequiredFields: ApiV3RequiredFieldsResponse | undefined
): Omit<ApiV3RequiredFieldsResponse, 'createdAt' | 'updatedAt' | 'doNotDistributeUntargetedEmissions'> & {
  doNotDistributeUntargeted?: boolean;
} {
  if (!apiV3RequiredFields) {
    return { unaddressedEmissionsDisplay: 'None' };
  }
  const { createdAt, updatedAt, doNotDistributeUntargetedEmissions, ...v3RequiredFields } = apiV3RequiredFields;
  return {
    ...v3RequiredFields,
    ...(doNotDistributeUntargetedEmissions ? { doNotDistributeUntargeted: doNotDistributeUntargetedEmissions } : {}),
  };
}
